import { formatNumber, Solana } from "@luma-team/shared";
import BigNumber from "bignumber.js";
import React from "react";

export const SolAmount = ({
  isDelta,
  precise = false,
  ...props
}: {
  lamports?: string | number | null | undefined;
  sol?: string | number | null | undefined;
  isDelta?: boolean;
  precise?: boolean;
} & ({ lamports: string | number } | { sol: string | number })) => {
  let solAmt: BigNumber;
  if ("lamports" in props) {
    solAmt = new BigNumber(props.lamports || 0).div(Solana.LAMPORTS_PER_SOL);
  } else {
    solAmt = new BigNumber(props.sol);
  }

  return (
    <>
      {formatNumber({
        num: solAmt.toNumber(),
        numDecimals: precise ? Solana.SOL_DECIMALS : undefined,
      })}{" "}
      SOL
    </>
  );
};
